import { useState, useEffect } from 'react';

const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Nuevo estado para el cargando

  useEffect(() => {
    const checkIfTouchDevice = () => {
      if (typeof window !== 'undefined') {
        const hasTouch = (
          'ontouchstart' in window || 
          navigator.maxTouchPoints > 0 || 
          navigator.msMaxTouchPoints > 0
        );
        setIsTouch(hasTouch);
        setIsLoading(false); // Finaliza el cargando
      }
    };

    checkIfTouchDevice();
  }, []);

  return { isTouch, isLoading }; // Devuelve ambos estados
};

export default useIsTouchDevice;
